<template>
  <div v-observer-log="sailing_c_x_homepage_realexposure_sw">
    <dl class="shop-card" @click="change(cardData)">
      <dt>
        <img
          class="bgImg"
          v-lazy="cardData.bgImg"
          data-width="300"
          :alt="cardData.shopName"
          :title="cardData.shopName"
        />
        <!-- logo图片 -->
        <img
          v-if="cardData.logoImg"
          class="logoImg"
          v-lazy="cardData.logoImg"
          data-height="72"
        />
        <!-- 店铺状态 -->
        <div
          class="shop-hide"
          v-if="
            (cardData.shopBizStatus && +cardData.shopBizStatus !== 1) ||
            (cardData.cShopStatus && +cardData.cShopStatus !== 1)
          "
        >
          <div>
            <p v-if="cardData.nextBizTimeDesc" class="next-time">
              <span>{{ $t('FoodC_Card2_When_the_sFOa') }}</span>
              {{ cardData.nextBizTimeDesc }}
            </p>

            <p class="shop-biz-status">
              {{ cardData.cShopStatusDesc }}
            </p>
          </div>
        </div>
      </dt>
      <dd>
        <!-- title&评价 -->
        <div class="shop-title">
          <p>{{ cardData.shopName }}</p>
          <div v-if="cardData.starRating && cardData.starRating.display === 1">
            <i class="el-icon-star-off" />
            <span>{{ cardData.starRating.score }}</span>
          </div>
        </div>
        <!-- 配送信息 -->
        <div
          class="delivery-info"
          :class="hasMoreInfo ? '' : 'has-more-info'"
          v-if="+cardData.cShopStatus === 1"
        >
          <!-- 配送时间 -->
          <span v-if="cardData.deliveryDesc && cardData.deliveryTime">{{
            cardData.deliveryDesc
          }}</span>
          <span v-else-if="cardData.deliveryTime"
            >{{ cardData.deliveryTime | secToMin }}{{ $t('分钟') }}</span
          >

          <i
            class="cirle"
            v-if="
              cardData.deliveryPriceAct &&
              +cardData.deliveryPriceAct !== 0 &&
              cardData.deliveryTime
            "
          ></i>
          <span
            v-if="cardData.deliveryPriceAct && +cardData.deliveryPriceAct !== 0"
          >
            <span class="separator" v-if="cardData.deliveryTimeRange" />
            <span
              v-if="+cardData.deliveryPriceOri === +cardData.deliveryPriceAct"
              class="deliveryPriceOri"
              >{{
                (cardData.deliveryPriceActSplit &&
                  cardData.deliveryPriceActSplit.display) ||
                cardData.deliveryPriceActDisplay
              }}
            </span>
            <span v-else>
              <span class="deliveryPriceAct" v-if="deliveryPriceActDisplay">{{
                deliveryPriceActDisplay
              }}</span>
              <s
                v-if="
                  deliveryPriceActDisplay &&
                  deliveryPriceActDisplay !== deliveryPriceOriDisplay
                "
                >{{ deliveryPriceOriDisplay }}</s
              >
            </span>
          </span>
          <i
            class="cirle"
            v-if="+cardData.deliveryPriceAct === 0 && cardData.deliveryTime"
          ></i>
          <span v-if="+cardData.deliveryPriceAct === 0" class="free-delivery">{{
            $t('免配送费')
          }}</span>
        </div>
        <!-- 标签区 包括 活动标签、推荐标签 -->
        <div class="shop-tags">
          <!-- 推荐标签 -->
          <div
            v-if="
              Array.isArray(cardData.recommendTag) &&
              cardData.recommendTag.length
            "
            class="shop-tag"
          >
            <shop-tag
              v-for="(item, index) in cardData.recommendTag"
              :key="index"
              :text="item"
            />
          </div>
          <!-- 活动标签 -->
          <div
            v-if="cardData.activity && cardData.activity.length"
            class="shop-tag"
          >
            <shop-tag
              v-for="(activity, index) in cardData.activity"
              :key="index"
              :text="activity"
            />
          </div>
          <div
            v-if="cardData.actTips && cardData.actTips.length"
            class="shop-tag"
          >
            <shop-tag
              v-for="(activity, index) in cardData.actTips"
              :key="index"
              :text="activity"
            />
          </div>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import strategyLog, { TYPE_MAP } from '@/config/trackLog/StrategyLog';
import { getRecId } from "@/config/trackLog/func";

import shopTag from './tag';

export default {
  name: 'ShopCard',
  filters: {
    secToMin(value) {
      return Math.ceil(Number(value) / 60);
    },
  },
  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
    cardType: {
      type: String,
      default: 'big',
    },
    module: {
      type: String,
      default: 'search',
    },
    cardInfo: {
      // 卡片全部信息
      type: Object,
      default: () => {},
    },
    pagenum: {
      // 页码：埋点需要
      type: Number,
      default: 0,
    },
    filterListIds: {
      // 筛选项id:埋点需要
      type: String,
      default: '',
    },
    insideIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    shopTag,
  },
  data() {
    return {
      shopStatusList: {
        1: this.$t('营业中'),
        2: this.$t('休息中'),
        3: this.$t('超出配送范围'),
        4: this.$t('暂停配送'),
        5: this.$t('休息中'),
      },
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    deliveryPriceOriDisplay() {
      return (
        (this.cardData?.deliveryPriceOriSplit &&
          this.cardData?.deliveryPriceOriSplit.display) ||
        this.cardData?.deliveryPriceOriDisplay
      );
    },
    deliveryPriceActDisplay() {
      return (
        (this.cardData?.deliveryPriceActSplit &&
          this.cardData?.deliveryPriceActSplit.display) ||
        this.cardData?.deliveryPriceActDisplay
      );
    },

    hasRecommendTag() {
      return (
        this.cardData.recommendTag &&
        Array.isArray(this.cardData.recommendTag) &&
        this.cardData.recommendTag.length > 0
      );
    },
    hasActivity() {
      return (
        this.cardData.activity &&
        Array.isArray(this.cardData.activity) &&
        this.cardData.activity.length > 0
      );
    },
    hasActTips() {
      return (
        this.cardData.actTips &&
        Array.isArray(this.cardData.actTips) &&
        this.cardData.actTips.length > 0
      );
    },
    hasMoreInfo() {
      return this.hasActivity || this.hasRecommendTag || this.hasActTips;
    },
    isFeed() {
      return this.$route.path.includes('feed');
    },
    sailing_c_x_homepage_realexposure_sw() {
      const {
        shopId,
        shopBizStatus,
        cShopStatus,
        currency,
        deliveryPriceOri = '',
        deliveryPriceAct = '',
        deliveryTime,
        deliveryType,
      } = this.cardData;
      const data = {
        eventId: this.isFeed
          ? 'sailing_c_x_homepage_realexposure_sw'
          : 'sailing_c_x_searchresult_realexposure_sw',
        eventLabel: this.isFeed ? '首页店铺实曝光' : '搜索结果页店铺实曝光',
        attrs: {
          shop_id: shopId,
          shop_status: cShopStatus || shopBizStatus,
          delivery_fee: `${currency}_${deliveryPriceOri}_${deliveryPriceAct}`,
          delivery_time: deliveryTime,
          delivery_type: deliveryType,
          lv1_location: this.lv1_location,
          meta: this.isFeed
            ? {
                page: 'homepage',
                page_num: this.pagenum,
                module: this.cardInfo.componentId,
                filterList: this.filterListIds,
                inside_index: this.insideIndex,
              }
            : {
                page: 'searchpage',
                page_num: this.pagenum,
                module: this.module,
                inside_index: this.insideIndex,
              },
        },
        tag: this.filterListIds, // 事件标识(筛选条件): 相同数据不同场景的上报
      };

      return data;
    },
    lv1_location() {
      const { componentId = 'default', position } = this.cardInfo || {};
      const l_index = this.insideIndex;
      const l_page = this.isFeed ? 'homepage' : 'searchpage';
      const l_componentId = this.isFeed ? componentId : this.module;
      const l_pagenum = this.pagenum; // 当前页码 (原 模块内页码)
      const l_row = this.isH5 ? 0 : Math.ceil((+l_index+1)/4) - 1; // 全局内行数 (原 模块内行数)
      const l_col = this.isH5 ? 0 :  +l_index%4; // 全局内列数 (原 模块内列数)
      const l_position = this.isFeed ? position : l_index;

      return strategyLog.getLv1Location({l_page, l_componentId, l_pagenum, l_row, l_col, l_position, l_index})
    }
  },
  mounted() {
  },
  methods: {
    change(cardData) {
      const clickEventId = this.isFeed ? 'sailing_c_x_homepage_shop_ck' : 'sailing_c_x_searchresult_shop_ck';
      
      strategyLog.setStrategyData(TYPE_MAP.LV1_INFO, {
        lv1_location: this.lv1_location,
        lv1_recid: getRecId(clickEventId),
      })

      const CK_DATA = this.$utils.cloneDeep(
        this.sailing_c_x_homepage_realexposure_sw
      );
      CK_DATA.eventId = clickEventId;
      CK_DATA.eventLabel = this.isFeed ? '首页商家点击' : '搜索结果页店铺点击';

      this.$trackEvent(CK_DATA);
      this.$router.push(`/store/${cardData.shopId}/${cardData.shopName}`);
      this.$emit('change', cardData);
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
